/* TRAWOC — count-up for the homepage "by numbers" band.
   Reads whatever figure is typed in the theme editor (e.g. "75K+", "95%",
   "6+", "1,000,000+"), counts from 0 to that number once the card scrolls
   into view, and keeps the text before/after the number as typed.
   Figures that are not numbers are left alone. No settings needed. */
(function () {
  var SEL = '[id$="__text_icon"] .x-block-columns .h3';
  function textNode(el) {
    /* skip the <style> Eurus prints inside each heading */
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
      acceptNode: function (t) {
        var p = t.parentNode && t.parentNode.nodeName;
        return (p === 'STYLE' || p === 'SCRIPT') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }
    }), n;
    while ((n = w.nextNode())) { if (/\d/.test(n.nodeValue)) return n; }
    return null;
  }
  function run(el) {
    var node = textNode(el); if (!node) return;
    var full = node.nodeValue, m = full.match(/^(\D*?)(\d[\d.,]*)([\s\S]*)$/); if (!m) return;
    var raw = m[2], target = parseFloat(raw.replace(/,/g, ''));
    if (!isFinite(target) || target <= 1) return;
    var dec = (raw.split('.')[1] || '').length, comma = raw.indexOf(',') > -1;
    var fmt = function (v) {
      var s = v.toFixed(dec);
      return comma ? Number(s).toLocaleString('en-IN', { minimumFractionDigits: dec, maximumFractionDigits: dec }) : s;
    };
    el.style.minWidth = el.offsetWidth + 'px';
    var t0 = null, dur = 1400;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
      node.nodeValue = m[1] + fmt(target * e) + m[3];
      if (p < 1) requestAnimationFrame(step); else node.nodeValue = full;
    }
    node.nodeValue = m[1] + fmt(0) + m[3];
    requestAnimationFrame(step);
  }
  function init() {
    var els = document.querySelectorAll(SEL);
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { io.unobserve(en.target); run(en.target); }
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
